import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "@/lib/data";
import { Reveal } from "./Reveal";

const Counter = ({ value, decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return <span ref={ref}>{n.toFixed(decimals)}</span>;
};

export const Stats = () => {
  return (
    <section className="relative mx-auto max-w-7xl px-4 pb-24 sm:px-8">
      <div className="grid grid-cols-2 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 lg:grid-cols-4">
        {STATS.map((s, i) => {
          const decimals = String(s.value).includes(".") ? 1 : 0;
          return (
            <Reveal
              key={i}
              delay={i * 0.08}
              className="group relative bg-void p-8 transition-colors hover:bg-surface"
              data-testid={`stat-${i}`}
            >
              <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-neon-pink to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
              <div className="font-display text-4xl text-white sm:text-6xl">
                {s.prefix && <span className="mr-1 text-lg align-top text-neon-cyan sm:text-2xl">{s.prefix}</span>}
                <span className="gradient-text">
                  <Counter value={s.value} decimals={decimals} />
                </span>
                {s.suffix && <span className="text-neon-pink">{s.suffix}</span>}
              </div>
              <p className="mt-3 font-mono-cap text-[10px] text-slate-400">{s.label}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
